import React,{useContext} from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import {GatsbyImage,getImage} from 'gatsby-plugin-image';
import { ModalFeature, ModalPicture } from '../../global.css';
import { FeatureStorageModal } from '../content/features';
import { BreakpointContext } from "../../providers/breakpoint";

const ModalStorage = () => {

  const styleAll = useContext(BreakpointContext);
  const modalPictureStyle = styleAll['ModalPictureStyle'];
  const modalFeatureStyle  = styleAll['ModalFeatureStyle'];

  const imageStyle = styleAll['ModalImageStyle'];
    const dataModalStorage = useStaticQuery(graphql`
    query dataModalStorageQuery {
        file(relativePath: {eq: "img_storage.png"}) {
            childImageSharp {
            gatsbyImageData(pngOptions: {quality: 80},placeholder: BLURRED)
          }
        }
      }  
        
      `);
      
      const image = getImage(dataModalStorage.file.childImageSharp.gatsbyImageData);
      
      const ftr = {
        hidden: { opacity: 0},
        show: {
          opacity: 1 ,
        transition:{ 
          type: "spring",
          mass: 0.25,
          stiffness: 75,
          duration:1,
          staggerChildren:0.5,                   
          delayChildren:0.5,
            
          }
        },
       
      };
    
    
        return (
              
          <>
          <ModalPicture
          key="modalpicturestorage"
          style={modalPictureStyle}
          >
            <GatsbyImage image={image} style={imageStyle} alt="CCTV-Health-Monitor-Image" />
          </ModalPicture>
          <ModalFeature
          key="modalfeaturestorage"
          variants={ftr}
          initial="hidden"
          animate="show"
          style={modalFeatureStyle}
          >
            <FeatureStorageModal/>
          </ModalFeature>
        </>      
            
        )
};
export default ModalStorage;